export type LandingThemeId =
  | 'indigo'
  | 'ocean'
  | 'sunset'
  | 'candy'
  | 'midnight';

export interface LandingThemeOption {
  id: LandingThemeId;
  label: string;
  swatch: string;
}

export const DEFAULT_LANDING_THEME: LandingThemeId = 'ocean';

export const LANDING_THEME_STORAGE_KEY = 'lp-preview-theme-v2';

export const LANDING_THEMES: LandingThemeOption[] = [
  {
    id: 'candy',
    label: 'Pushti',
    swatch: '#ec4899',
  },
  {
    id: 'indigo',
    label: 'Binafsha',
    swatch: '#4f46e5',
  },
  {
    id: 'ocean',
    label: 'Moviy',
    swatch: '#0ea5e9',
  },
  {
    id: 'sunset',
    label: 'Apelsin',
    swatch: '#f97316',
  },
  {
    id: 'midnight',
    label: "To'q ko'k",
    swatch: '#1d4ed8',
  },
];

export function isLandingThemeId(value: string | null): value is LandingThemeId {
  return LANDING_THEMES.some((theme) => theme.id === value);
}
